export class KYCReSubmissionModel{
    calculationId: number;
    referenceId?: string;
    deviceType: string; 
  }